<template>
  <div class="header">
    <div><slot /></div>
    <div class="header__actions">
      <v-btn
        v-if="showFullScreenButton"
        icon
        color="primary"
        @click="$emit('toggle-full-screen')"
      >
        <v-icon>icon-fullscreen</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewsCategoriesHeatmapHeader",
  data() {
    return {
      showFullScreenButton: false
    };
  }
};
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: $spacing * 1.5;

  &__actions {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
